var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 12C2.66699 8.22876 2.66699 6.34315 3.83857 5.17157C5.01014 4 6.89576 4 10.667 4H14.667C18.4382 4 20.3238 4 21.4954 5.17157C22.667 6.34315 22.667 8.22876 22.667 12V14C22.667 17.7712 22.667 19.6569 21.4954 20.8284C20.3238 22 18.4382 22 14.667 22H10.667C6.89576 22 5.01014 22 3.83857 20.8284C2.66699 19.6569 2.66699 17.7712 2.66699 14V12Z",
    stroke: "#2D3546",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66699 4V2.5",
    stroke: "#2D3546",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.667 4V2.5",
    stroke: "#2D3546",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.167,
    cy: 16.5,
    r: 1.5,
    stroke: "#2D3546",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16699 9H22.167",
    stroke: "#2D3546",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4814186074d64a8d13fe43f466aeeb36.svg";
export { ForwardRef as ReactComponent };